<template>
    <div class="inner-container"
        :class="{'full-width-preview': (step < 1)}">
        <!-- <div v-if="cartBtnClicked" class="loading-bar-container"> -->
        <div class="loading-bar-container" :class="{'hidden': !cartBtnClicked}">
            <div class="loader-content">
                <div class="loading-bar" role="button" ref="loadingbar" ></div>
                <div class="message">Bitte hab einen Augenblick Geduld, während wir dein Portrait für den Druck vorbereiten.</div>
            </div>
        </div>
        <div id="preview-column" class="preview-column"
            :class="[
                'step-' + step,
                (step >= 4 && step <= 5) ? 'bg-room' : ''
            ]"
        >
            <Header header-mobile="true"></Header>
            <div class="ml-5 cursor-pointer dismiss-modal dismiss-modal-step-0" data-dismiss="modal" v-if="step < 1"><span class="icon-close"></span></div>
            <div class="preview-wrapper flex"
                :class="{
                    'flex-center': (step >= 1 && step <= 3)
                }">
                <div id="preview-container"
                    :class="{
                        'pt-5': step == 1,
                        'm-auto': step < 1
                    }">
                    <PreviewPanel></PreviewPanel>
                    <InvisibleWaveCanvas></InvisibleWaveCanvas>
                    <InvisibleQrCode></InvisibleQrCode>
                </div>
            </div>
        </div>
        <div class="action-column"
            :class="[
                'step-' + step,
                (step < 1) ? 'hidden' : ''
            ]">
            <div class="flex flex-col action-column-inner">
                <Header class="scroll-shadow header-bar-wrapper" :class="{'shadow-bottom': !scrolledTop}"></Header>

                <div class="control-panel relative" ref="controlpanel">
                    <ControlPanel></ControlPanel>
                </div>

                <AddToCart class="scroll-shadow add-to-cart" :class="{'shadow-top': !scrolledBottom}"></AddToCart>
            </div>
        </div>

    </div>
</template>

<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';
import ControlPanel from './Layout/ControlPanel.vue';
import PreviewPanel from './Layout/PreviewPanel.vue';
import AddToCart from './Layout/ControlPanel/AddToCart.vue';
import InvisibleWaveCanvas from './Layout/PreviewPanel/InvisibleWaveCanvas.vue';
import InvisibleQrCode from './Layout/PreviewPanel/InvisibleQrCode.vue';
import Header from './Layout/ControlPanel/Header.vue';
import TmpStepSelection from  './Layout/ControlPanel/TmpStepSelection.vue';
import Pipeline from "./Pipeline/Pipeline.js";
import ColorPickerVue from './Components/ColorPicker.vue';


export default {
    components: {
        ControlPanel,
        PreviewPanel,
        InvisibleWaveCanvas,
        InvisibleQrCode,
        Header,
        TmpStepSelection,
        AddToCart
    },
    computed: {
        ...mapFields({
            step: 'step',
            substep: 'substep',
            stepQrOpened: 'stepQrOpened',
            stepsDisabled: 'stepsDisabled',
            cartBtnClicked: 'cartBtnClicked',
            substepsDisabled: 'substepsDisabled',
            loaderPercentage: 'loaderPercentage',
            availableSubsteps: 'availableSubsteps',
        })
    },
    data() {
        return {
            scrolledTop: true,
            elasticProgress: {},
            loaderStarted: false,
            scrolledBottom: true,
        };
    },
    watch: {
        /**
         * Run render pipeline everytime the step changes
         * @param step
         */
        step(step) {
            Pipeline.wavesDraggable((step == 2) && !this.$store.state.soundFilesChanged);
            Pipeline.removeBackgroundCropControls();
            if (!this.$store.state.soundFilesChanged) {
                Pipeline.removeWaveTransformers();
            }
            Pipeline.enableTextTransformers(step == 3);
            // Pipeline.enableBackgroundTextTransformers(step == 3);

            this.$nextTick(() => {
                const controlPanel = document.querySelector('.control-panel');
                const currentStepContainer = document.querySelector(`.step-container.step-${step}`);
                if (controlPanel && currentStepContainer &&
                    (this.availableSubsteps[step] == 0 || this.substep == 1)) {
                    controlPanel.scrollTo({
                        top: currentStepContainer.offsetTop - 4,
                        behavior: 'smooth'
                    });
                }
            });

            if (step > 3) {
                if (step == 5) {
                    Pipeline.runQRCodePipeline();
                }

                Pipeline.generateFinalImagePreview();
            }

            if (step == 5) {
                this.stepQrOpened = true;
            }

            if (this.availableSubsteps[step] == 0) {
                this.enableNextStep();
            }
        },

        substep(substep) {
            // enable next substep if more substeps available
            if (this.hasNextSubstep(substep)) {
                this.enableNextSubstep();
            }

            // enable next step if current accordion is the last substep of parent step
            if (this.availableSubsteps[this.step] == substep) {
                this.enableNextStep();
            }
        },

        cartBtnClicked() {
            if (this.cartBtnClicked) {
                this.$refs.loadingbar.innerHTML = '';
                this.$nextTick(() => {
                    this.elasticProgress = new ElasticProgress(this.$refs.loadingbar, {
                        width: 220,
                        height: 60,
                        barInset: 6,
                        barHeight: 10,
                        align: "center",
                        colorBg: "#606c38",
                        colorFg: "#8ba240",
                        textFail: "Fehler",
                        arrowDirection: "up",
                        arrowHangOnFail: true,
                        highlightColor: "#ffab91",
                        textComplete: "Erledigt!",
                        onOpen: () => {
                            this.loaderStarted = true;
                        }
                    });

                    this.elasticProgress.open();
                });
            }
        },

        loaderPercentage() {
            if (this.loaderPercentage === 1) {
                this.elasticProgress.complete();
                return;
            }

            this.elasticProgress.setValue(this.loaderPercentage);
        }
    },
    methods: {
        beforeunload(event) {
            // destroy stage before unload if present to remove canvas from browser cache
            if (this.$store.state.stage !== null && typeof this.$store.state.stage.destroy === 'function') {
                this.$store.state.stage.destroy();
            }
        },
        scrollControlPanel(event) {
            const { target } = event;

            this.scrolledTop = target.scrollTop == 0;
            this.scrolledBottom = target.scrollTop == target.scrollTopMax;
        },

        navigateForward() {
            const substeps = this.availableSubsteps[this.step];
            if (substeps > 0 && this.substep < substeps) {
                this.substep = this.substep + 1;
                return;
            }

            this.enableNextStep();
            this.step = (this.step + 1);
            this.substep = 1;
        },

        navigateBack() {
            const substeps = this.availableSubsteps[this.step];
            if (substeps > 0 && this.substep > 1) {
                this.substep = this.substep - 1;
                return;
            }

            this.step = (this.step - 1);
            this.$nextTick(() => {
                this.substep = this.availableSubsteps[this.step] > 0 ? this.availableSubsteps[this.step] : 1;
            });
        },

        enableNextStep() {
            const nextStep = (this.step + 1);
            // remove next step from
            const disabledIndex = this.stepsDisabled.indexOf(nextStep);
            if (disabledIndex !== -1) {
                this.stepsDisabled.splice(disabledIndex, 1);
                this.$store.commit('updateField', {
                    path: 'stepsDisabled',
                    value: this.stepsDisabled
                });
            }
        },

        enableNextSubstep() {
            // remove next substep from
            const nextSubstep = (this.substep + 1);
            const disabledIndex = this.substepsDisabled[this.step].indexOf(nextSubstep);
            if (disabledIndex !== -1) {
                this.substepsDisabled[this.step].splice(disabledIndex, 1);
                this.$store.commit('updateField', {
                    path: 'substepsDisabled',
                    value: this.substepsDisabled
                });
            }
        },

        hasNextSubstep(substep) {
            return this.availableSubsteps[this.step] &&
                this.availableSubsteps[this.step] > 0 &&
                this.substepsDisabled[this.step] &&
                this.substepsDisabled[this.step].length > 0 &&
                this.substepsDisabled[this.step].indexOf(substep + 1) !== -1;
        }
    },
    created() {
        window.addEventListener('beforeunload', this.beforeunload);
    },
    beforeMount() {
        // this.$store.commit('loadState');
        // this.$store.commit('generateUniqueId');
        this.$store.dispatch('init');
    },
    mounted() {
        Pipeline.runPipeline(true);
        const ayvModal = document.getElementById('ayv-configurator-modal');
        this.$refs.controlpanel.addEventListener('scroll', this.scrollControlPanel);

        ayvModal.addEventListener('ayvModalOpened', () => {
            if (this.$store.state.openingStep) {
                this.$store.state.step = this.$store.state.openingStep;
                this.$store.state.openingStep = null;
            }

            Pipeline.setResponsiveStageWidth();

            window.addEventListener('resize', () => {
                Pipeline.setResponsiveStageWidth();
                Pipeline.setResponsivePreviewSize()
            });

            // prevent users from zooming via pinch to zoom, because canvas redrawing lets mobile browsers crash
            document.addEventListener('touchmove', function (event) {
                if (event.scale !== 1) {
                    event.preventDefault();
                }
            }, { passive: false });

            // prevent users from zooming via double-tap
            let lastTouchEnd = 0;
            document.addEventListener('touchend', function (event) {
                let now = (new Date()).getTime();
                if (now - lastTouchEnd <= 300) {
                    event.preventDefault();
                }
                lastTouchEnd = now;
            }, { passive: false });
        });

        this.$root.$on('enableNextStep', () => {
            this.enableNextStep();
        });

        ayvModal.addEventListener('navigateForward', () => {
            this.navigateForward();
        });

        ayvModal.addEventListener('navigateBack', () => {
            this.navigateBack();
        });
    }
};
</script>
